import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { AppTourService } from '../services';
import { UserPreferencesState } from '../state';

@Injectable()
export class TourInterceptor implements HttpInterceptor {
  private _tourMode: { enabled: boolean; started: boolean };

  constructor(
    private store: Store,
    private appTourService: AppTourService,
  ) {
    this.store.select(UserPreferencesState.tourMode).subscribe((mode) => {
      this._tourMode = {
        enabled: mode.enabled,
        started: mode.toursStarted,
      };
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (
      this._tourMode.enabled &&
      this._tourMode.started &&
      req.method === 'GET'
    ) {
      const { url, params } = req;

      this.appTourService.fetchTourRequest(url, params);

      return this.appTourService.getTourResponse(url).pipe(
        filter((res) => res !== undefined), // null is allowed (represents empty data).
        take(1),
        switchMap((data) => {
          if (data) {
            return of(new HttpResponse({ status: 200, body: data }));
          } else {
            return next.handle(req);
          }
        }),
      );
    }

    return next.handle(req);
  }
}
